module.exports = __webpack_public_path__ + "img/MX-B048045A-BS-HQ.8fb12a1f.png";